module.exports = __webpack_public_path__ + "img/big_gaming.2f9ef677.jpg";